export default __webpack_public_path__ + "d5e6894.png";